import { render, staticRenderFns } from "./mainTaskLog.vue?vue&type=template&id=52d3de25&"
import script from "./mainTaskLog.vue?vue&type=script&lang=js&"
export * from "./mainTaskLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52d3de25')) {
      api.createRecord('52d3de25', component.options)
    } else {
      api.reload('52d3de25', component.options)
    }
    module.hot.accept("./mainTaskLog.vue?vue&type=template&id=52d3de25&", function () {
      api.rerender('52d3de25', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpGameLog/mainTaskLog.vue"
export default component.exports